import { USD } from 'helpers/formatters/number_formats';
import { leaseRateMappings } from 'bundles/research/index/research_constants';

const defaultCurrencyOptions = { round: true };

export default class CurrencyFormatter {
  format(filterValue, options = {}) {
    const currencyOptions = this.extractCurrencyOptions(options);
    return USD.format(filterValue, currencyOptions);
  }

  formatRange(filterMinValue, filterMaxValue, options = {}) {
    const currencyOptions = this.extractCurrencyOptions(options);
    let formattedRange;

    if (filterMinValue && filterMaxValue) {
      formattedRange = [filterMinValue, filterMaxValue]
        .map(value => USD.format(value, currencyOptions))
        .join(' - ');
    } else if (filterMinValue) {
      formattedRange = `≥ ${USD.format(filterMinValue, currencyOptions)}`;
    } else if (filterMaxValue) {
      formattedRange = `≤ ${USD.format(filterMaxValue, currencyOptions)}`;
    }

    if (formattedRange) {
      return formattedRange + this.getSuffix(options);
    } else {
      return '';
    }
  }

  extractCurrencyOptions = options => ({ ...defaultCurrencyOptions, ...(options.currencyOptions || {}) });

  getSuffix(options) {
    if (options.units) {
      const rateMapping = leaseRateMappings[options.units];
      const rateText = rateMapping ? rateMapping.label : options.units;
      return ` ${rateText}`;
    } else {
      return '';
    }
  }
}
